import { getEmbedAppUrl } from '@/utils/getEmbedAppUrl';
import { useStore } from 'vuex';

export const useGoToPricing = () => {
  const store = useStore();

  const shopDomain = computed(() => store.state.app.shopInfo?.shopifyDomain);
  const embedAppUrl = computed(() => getEmbedAppUrl(shopDomain.value));

  const pricingUrl = computed(() => {
    const params = new URLSearchParams({
      from: 'editor-v6',
    });

    return `${embedAppUrl.value}/pricing?${params}`;
  });

  const goToPricing = () => {
    window.open(pricingUrl.value, '_blank');
  };

  const applyEventOpenNewTab = (e: Event, item: Element) => {
    e.preventDefault();
    e.stopPropagation();
    const url = item.getAttribute('data-href');
    url && window.open(url, '_blank');

    return;
  };

  onMounted(() => {
    const gpOpenNewTabs = document.getElementsByClassName('gp-open-new-tab');
    Array.from(gpOpenNewTabs).forEach((item: Element) => {
      if (item.classList.contains('gp-open-new-tab--apply-event')) return;

      item.classList.add('gp-open-new-tab--apply-event');
      item.addEventListener('click', (e: Event) => applyEventOpenNewTab(e, item));
    });
  });

  return {
    pricingUrl,
    goToPricing,
  };
};
